import { useNavigate } from 'react-router-dom';

import { Button, Flex } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';

import Help from '@/pages/help/help';
import Settings from '@/pages/settings/Settings.tsx';

import useLogout from '@/hooks/useLogout.ts';

import { AppRoutes } from '@/router/routes.ts';

import useAppStore from '@/shared/store/app.store';

const UserProfileMenu = () => {
	const navigate = useNavigate();
	const logout = useLogout();

	const [openedSettings, { close: closeSettings, open: openSettings }] = useDisclosure(false);
	const [openedHelp, { close: closeHelp, open: openHelp }] = useDisclosure(false);

	const isMobile = useAppStore((state) => state.isMobile);

	const handleLogout = () => {
		void logout();
	};

	const handleShowHelp = () => {
		if (isMobile) {
			openHelp();
		} else {
			navigate(AppRoutes.Help);
		}
	};

	const handleShowSettings = () => {
		if (isMobile) {
			openSettings();
		} else {
			navigate(AppRoutes.Settings);
		}
	};

	const menuItems = [
		{
			label: 'Настройки',
			action: handleShowSettings,
		},
		{
			label: 'Помощь',
			action: handleShowHelp,
		},
		{
			label: 'Выйти',
			action: handleLogout,
		},
	];

	return (
		<>
			<Flex direction="column">
				{menuItems.map((item) => (
					<Button
						key={item?.label}
						variant="white"
						c="#000000"
						radius="lg"
						size="md"
						onClick={item.action}
						justify="start"
						fullWidth
					>
						{item.label}
					</Button>
				))}
			</Flex>
			{isMobile && (
				<>
					<Settings isOpen={openedSettings} onClose={closeSettings} />
					<Help isOpen={openedHelp} close={closeHelp} />
				</>
			)}
		</>
	);
};

export default UserProfileMenu;
